import { isGiftCardSingle } from './isGiftCardSingle';
export const getGiftCardTitle = (giftCard) => {
    if (isGiftCardSingle(giftCard)) {
        return giftCard.code;
    }
    return `${giftCard.giftCards[0].code} ${giftCard.giftCards.length > 1 ? ` (+${giftCard.giftCards.length - 1})` : ''}`;
};
